import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import labels from './labels';
import meters from './meters';
import service from './service';
import settings from './settings';
import regeneration from './regeneration';
import workflow from './workflow';

export default combineReducers({
  labels,
  meters,
  service,
  settings,
  regeneration,
  workflow,
  router: routerReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js